import React from "react";
import aboutImg2 from "../assets/images/about-2.png";
const About = () => {
  const info = [
    { text: "Full Stack Projects", count: "05" },
    { text: "Completed Projects", count: "30" },
  ];
  const social_media = [
    {
      logo: "logo-linkedin",
      link: "https://www.linkedin.com/in/nahid-parvez-np/",
    },
    {
      logo: "logo-github",
      link: "https://github.com/parvez1407",
    },
    {
      logo: "logo-facebook",
      link: "https://www.facebook.com/nahid1407/",
    },
  ];
  return (
    <section id="about" className="py-10 text-white bg-gray-800">
      <div className="text-center my-8">
        <h3 className="text-5xl font-semibold mb-5">
          Introduce <span className="text-indigo-600">Myself</span>
        </h3>
        <div className="flex md:flex-row flex-col-reverse items-center md:gap-6 gap-12 px-10 max-w-6xl mx-auto">
          <div className="p-2">
            <div className="text-gray-300 my-3">
              <p className="text-justify leading-7 w-11/12 mx-auto">
                I'm Nahid Parvez, a Web Developer from Bangladesh. <br />I am
                expert with HTML, CSS, Bootstrap, React Bootstrap, Tailwind CSS,
                JavaScript, ES6, React.js and conformable with Node.js,
                Express.js, Firebase & MongoDB. I consider myself as a quick
                learner, self- motivated, responsible, disciplined and
                deadline-oriented person who can work under pressure and solve
                problems in a critical situation with analytical knowledge and
                the latest technology.
                <br />I am not only fond of the Web Development work that I do,
                but I take great pride in it, as well.
              </p>
              <div className="flex mt-10 items-center gap-7 ml-7">
                {info.map((content) => (
                  <div key={content.text}>
                    <h3 className="md:text-4xl text-2xl font-semibold text-white">
                      {content.count}
                      <span className="text-indigo-600">+</span>{" "}
                    </h3>
                    <span className="md:text-base text-xs">{content.text}</span>
                  </div>
                ))}
              </div>
              <br />
              <p className="text-base text-left ml-7">connect me-</p>
              <div className="mt-2 text-3xl flex items-center md:justify-start justify-center gap-5 ml-7 bg-transparent">
                {social_media?.map((icon) => (
                  <a
                    href={icon.link}
                    key={icon.logo}
                    target="_blank"
                    className="text-gray-500 hover:text-indigo-500 cursor-pointer transform transition duration-500 hover:scale-125"
                  >
                    <ion-icon name={icon.logo}></ion-icon>
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="flex-1 md:mt-0 mt-6 flex justify-center items-center">
            <div className="lg:w-96 h-full relative sm:w-10/12 w-11/12 max-w-sm aboutImg ">
              <img
                src={aboutImg2}
                alt=""
                style={{ background: "#283F54" }}
                className="w-full object-cover  rounded-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
